import "../Skills/Skills.css"
import { motion } from 'framer-motion';
export default function Skills(){
    return <div
    className="SkillMainDiv"
    >
    <motion.div className="MainSkills" 
     
    initial={{
        opacity:0,
        x:-40
    }}
    whileInView={{
        opacity:1,
        x:0
    }}
    transition={{
        duration:0.7
    }}
    >
        Skills
    </motion.div>
    <div className="SkillsDiv">
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:"20px"}}>
        <EachSkill iconName={"fa-brands fa-envira"} color={"green"} FristLetter={"M"} letter={"ongoose"}/>
        <EachSkill iconName={"fa-solid fa-e"} color={"brown"} FristLetter={"E"} letter={"xpress"}/>
        <EachSkill iconName={"fa-brands fa-react"} color={"lightblue"} FristLetter={"R"} letter={"eact"}/>
        <EachSkill iconName={"fa-brands fa-node-js"} color={"green"} FristLetter={"N"} letter={"ode Js"}/>
        <EachSkill iconName={"fa-brands fa-n"} color={"white"} FristLetter={"N"} letter={"ext.Js"}/>
    </div>
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:"20px"}}>
        <EachSkill iconName={"fa-solid fa-mobile-screen-button"} color={"darkblue"} FristLetter={"F"} letter={"lutter"}/>
        <EachSkill iconName={"fa-brands fa-square-js"} color={"yellow"} FristLetter={"J"} letter={"avaScript"}/>
        <EachSkill iconName={"fa-solid fa-terminal"} color={"blue"} FristLetter={"T"} letter={"ypeScript"}/>
        <EachSkill iconName={"fa-solid fa-code"} color={"lightblue"} FristLetter={"C"} letter={"++"}/>
        <EachSkill iconName={"fa-regular fa-file-code"} color={"brown"} FristLetter={"C"} letter={""}/>
    </div>
    </div>
    </div>
}
function EachSkill({iconName,color,FristLetter,letter}){
    return <div style={{
        display:"flex",
        justifyContent:"space-between",
        width:"100%"
    }}>
        <motion.div 
        initial={{
            opacity:0,
            x:-40
        }}
        whileInView={{
            opacity:1,
            x:0
        }}
        transition={{
            duration:0.7
        }}
        className="EachSkill"><i className={iconName} style={{color:`${color}`}}> </i><span className="FristLetter">&nbsp; {FristLetter}</span><span>{letter}</span></motion.div>
    </div>
}